export default __webpack_public_path__ + "static/media/BountyHunter_HTB.f2ceef32.md";